/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import styles from './style/index.module.less';

const CircleLoading = () => (
  <div className={styles.com__box}>
    <div className={styles.loading}>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
      <div className={styles.item}></div>
    </div>
  </div>
);

export default (CircleLoading);
